import httpClient, { HTTP_STATUS_CODE } from './http_client';

export { HTTP_STATUS_CODE };
export default httpClient;
